// extracted by mini-css-extract-plugin
export var breadcrumbPadding = "headerText-module--breadcrumbPadding--43397";
export var heroTextContainer = "headerText-module--heroTextContainer--8109b";
export var heroTextContent = "headerText-module--heroTextContent--a7696";
export var heroTextGrid = "headerText-module--heroTextGrid--65e95";
export var heroTextGridBlock = "headerText-module--heroTextGridBlock--749cf";
export var heroTextSection = "headerText-module--heroTextSection--83da8";
export var heroTextTagline = "headerText-module--heroTextTagline--3eae0";